const updateParams = params => {

  let paramsStr = JSON.stringify(params);
  localStorage.setItem('params', paramsStr);

  return {
    type: 'UPDATE_PARAMS',
    payload: params
  };
};

export default updateParams;

export const resetParams = () => {
  localStorage.clear();
  return {
    type: 'UPDATE_PARAMS',
    payload: {
      categories:[],
      subcategories:[],
      limit: 18,
      from: 0,
      selectedCategory: [],
      selectedSubCategories: [],
      paymentMethods: [],
      deliveryMethods: [],
      specialCategories: [],
      search: '',
      location:'',
      locationTxt:'',
      locationType:'',
      locationValue:'',
      filters: {
        womanPyme: false,
        cooperative: false,
        shipingProducts: false,
        pickup: false,
        paymentMethodCash: false,
        paymentMethodCreditDebitCard: false,
        paymentMethodTransfers: false
      }
    }
  };
};
